import React from 'react';

import { useDeleteFace, useGetFace, useGetFaces } from '@vlabs/api/artemy/client';
import type { FaceId } from '@vlabs/api/artemy/model';
import { DeleteIcon } from '@vlabs/icons';
import { DropdownListNegativeItem } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { confirmLastFaceDeletion } from '../../entities/cards';

interface DeleteFaceDropdownItemProps {
  faceId: FaceId;
  onDeleteFace: VoidFunction;
}

export function DeleteFaceDropdownItemPoint3({
  faceId,
  onDeleteFace,
}: DeleteFaceDropdownItemProps): React.JSX.Element {
  const { t } = useTranslation();
  const getFace = useGetFace(faceId);
  const deleteFace = useDeleteFace();
  const countFaces = useGetFaces({ card_ids: getFace.data?.card_id ? [getFace.data.card_id] : undefined }, {
    query: {
      enabled: !!getFace.data?.card_id,
    },
  });
  const $onDeleteFace = async () => {
    if (getFace.data?.card_id && (countFaces.data?.faces?.length ?? 0) === 1) {
      await confirmLastFaceDeletion({ onConfirm: onDeleteFace, async: true });
    }
    await deleteFace.mutateAsync({ faceId });
    onDeleteFace?.();
  };

  return (
    <DropdownListNegativeItem
      label={t('features:deleteFace.btn.delete')}
      leftIcon={<DeleteIcon />}
      onClick={$onDeleteFace}
    />
  );
}
